import React, { Component  } from 'react';
import ReactDOM from 'react-dom';

import './index.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            items: []
        };
    }
    componentDidMount() {
        fetch("https://api-v2.coophi.com/changelogs")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    dateFormatter = (date) => {
        const newDate = new Date(Date.parse(date)).toDateString();
        return (newDate);
    };
    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <div className={'container'}>
                    <div className={'content'}>
                        <img src='https://storage.googleapis.com/coophi-files/5a652bce3153020420c14ebd/1521438579136-logo-and-pet.png' alt='coophi-pet'/>
                        <h1>Changelog</h1>
                        {items.map(item=>(
                            <div key={item._id}>
                            <hr/>
                            <h3>{item.name}
                            <span>{this.dateFormatter(item.date)}</span>
                            </h3>
                                <ul className={'list green'}>
                                    {item.feature.map(change=>(
                                        <li key={change}>
                                            <span>Nueva característica</span><p>{change}</p>
                                        </li>
                                    ))}
                                </ul>
                                <ul className={'list blue'}>
                                    {item.improvement.map(change=>(
                                        <li key={change}>
                                            <span>Mejora</span><p>{change}</p>
                                        </li>
                                    ))}
                                </ul>
                                <ul className={'list red'}>
                                    {item.bugFix.map(change=>(
                                        <li key={change}>
                                            <span>Corrección de errores</span><p>{change}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                </div>
                    </div>
            );
        }
    }
}


// ========================================

ReactDOM.render(
    <App />,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js